module.exports = __webpack_public_path__ + "img/cloud-drizzle-lightning-moon.dba99f94.svg";